import { h, Fragment } from 'preact'
import { FlertallInfo, PartiResultatMedMandat } from '../../../../domain'
import cx from 'classnames'

import styles from './Graph.module.css'
import { Message } from '../../../../../lib/intl/Message'

type Props = {
  resultater: PartiResultatMedMandat[]
  totaltAntallMandater: number
  forrigeTotaltAntallMandater: number
}

type BarItem = { value: number; color: string }
type BarProps = {
  items: BarItem[]
  result: number
  target: number
  title: string
  summary: string
  secondary?: boolean
}

export function Graph({ resultater, totaltAntallMandater, forrigeTotaltAntallMandater }: Props) {
  const thisYear: BarProps = {
    title: 'beholder-de-flertallet-bar-tittel-valget-i-år',
    summary: 'beholder-de-flertallet-bar-tittel-fordeling',
    result: resultater.reduce((acc, cv) => acc + (cv.mandater.antall || 0), 0),
    target: totaltAntallMandater,
    items: resultater.map(resultat => {
      return {
        value: (resultat.mandater.antall || 0) / totaltAntallMandater,
        color: resultat.parti.farge
      }
    })
  }

  const previousYear: BarProps = {
    title: 'beholder-de-flertallet-bar-tittel-valget-sist',
    summary: 'beholder-de-flertallet-bar-tittel-fordeling',
    result: resultater.reduce(
      (acc, cv) => acc + (cv.mandater.antall || 0) - cv.mandater.endring,
      0
    ),
    target: forrigeTotaltAntallMandater,
    items: resultater.map(resultat => {
      const antall = (resultat.mandater.antall || 0) - resultat.mandater.endring
      return {
        value: antall / forrigeTotaltAntallMandater,
        color: resultat.parti.fargeSvak
      }
    })
  }

  return (
    <Fragment>
      <div class={styles.wrapper}>
        <Bar {...thisYear} />
        <Bar {...previousYear} secondary />
      </div>
    </Fragment>
  )
}

function Bar({ items, result, target, title, summary, secondary }: BarProps) {
  return (
    <div class={styles.barContainer}>
      <div class={cx(styles.barTitle, secondary && styles.barTitleMuted)}>
        <Message id={title} class={`${styles.barTitleItem} ${styles.barTitleItemBold}`} />
        <Message id={summary} class={styles.barTitleItem} values={{ result, target }} />
      </div>
      <div class={styles.barGraphWrapper}>
        {items.map(item => {
          return (
            <div
              class={cx(styles.barGraph, secondary && styles.barGraphSmall)}
              style={{
                width: `${item.value * 100}%`,
                backgroundColor: item.color
              }}
            />
          )
        })}
      </div>
    </div>
  )
}
